// import React, { useState } from "react";
import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useLocation } from "react-router-dom";
// import { sendEvent } from "@app/Helpers";
import "./style.scss";

// import { ACTIVATION_CACHE_TIME, getActivationDescribe } from "@api/activation";

import Button from "@components/Button";
import SectionHeader from "@components/SectionHeader";

export default NiceModal.create(() => {
  const { pathname } = useLocation();
  const modal = useModal();
  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      disableClose={false}
      onAfterClose={() => modal.remove()}
      innerClass={`static-award-modal`}
    >
      <div className="content-wrapper">
        <div className="top-content">
          <SectionHeader>
            <strong>Ultra</strong>Experience Berlin P61
          </SectionHeader>
        </div>
        <div className="content">
          <p className="copy">
            Die <strong>UltraExperience.</strong> ist ein multisensorisches,
            interaktives Erlebnis. Konzipiert, um deine Einzigartigkeit zu
            feiern.
          </p>
          {/* <p className="copy">
            Am <strong>4. & 5. Juli*</strong> verwandelt sich die
            <strong> P61 Gallery in Berlin </strong> in einen immersiven
            Schauplatz für <strong>Selbstausdruck, Kreativität </strong>
             und <strong>echte Verbindungen.</strong> <br />
            Unsere handverlesenen Artists sorgen für 
            <strong> pulsierende Energie</strong>
            , erstklassige Beats und eine elektrisierende Atmosphäre.
          </p> */}
          <p className="copy">
            Mehr Informationen zum Event und zur Anmeldung findest Du hier.
          </p>
          {/* <p className="copy">
            Die <strong>Plätze sind limitiert</strong> – sichere dir jetzt
            deinen Spot**, bevor es zu spät ist.
          </p> */}

          {/* <div className="disclaimers">
            <span>
              *Du kannst dich nur für einen Tag anmelden – entweder den 4. oder
              den 5. Juli. Entscheide weise!
            </span>
            <span>
              **Mit der Anmeldung hast du noch keinen sicheren Platz – wer
              zuerst kommt, feiert zuerst! Also sei besser früh genug da!
            </span>
          </div> */}
          <Button
            action={() => {
              // sendEvent(`ULTRAEXPERIENCE_COUPON_CLICKED`);
              window.dataLayer.push({
                event: "ultraexperience_coupon_clicked",
                pathname: pathname,
              });
            }}
            type="button"
            href={"https://ultra-experience.de/"}
          >
            Zum Event Anmelden
          </Button>
        </div>
      </div>
    </Modal>
  );
});
